/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
export {};

// eslint-disable-next-line global-require
const i18nConfig = require("../../../../i18n");

const { locales, defaultLocale } = i18nConfig as {
  locales: string[];
  defaultLocale: string;
};

String.prototype.getLanguage = (): string => {
  const languageInURL = window.location.href.split("/");
  let language = defaultLocale;
  locales.forEach((item: string) => {
    if (languageInURL.includes(item)) {
      language = item;
    }
  });

  return language;
};
